module.exports = __webpack_public_path__ + "static/media/sekiro.997e22d0.png";